/* tslint:disable */
/* eslint-disable */
/**
 * Nightingale API
 *  ### Welcome to the Nightingale API !   To use the Nightingale API, you will need a `access_token` from **Bridgetech Support**  ## How to use swagger documentation   Click `Authorize` and paste your  `access_token` as `bearerAuth`  ## Design Notes 1. For non-mandatory fields, the API will allow you to submit `null` *or* omit fields entirely. 2. All query parameters are optional. Pagination fields default as follows: * page = 1 * limit = 20
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StoreTeamRequest
 */
export interface StoreTeamRequest {
    /**
     * 
     * @type {string}
     * @memberof StoreTeamRequest
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof StoreTeamRequest
     */
    client_id: number;
}

/**
 * Check if a given object implements the StoreTeamRequest interface.
 */
export function instanceOfStoreTeamRequest(value: object): value is StoreTeamRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('client_id' in value) || value['client_id'] === undefined) return false;
    return true;
}

export function StoreTeamRequestFromJSON(json: any): StoreTeamRequest {
    return StoreTeamRequestFromJSONTyped(json, false);
}

export function StoreTeamRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreTeamRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'client_id': json['client_id'],
    };
}

export function StoreTeamRequestToJSON(json: any): StoreTeamRequest {
    return StoreTeamRequestToJSONTyped(json, false);
}

export function StoreTeamRequestToJSONTyped(value?: StoreTeamRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'client_id': value['client_id'],
    };
}

